module.exports = __webpack_public_path__ + "img/056-briefcase.588a58c4.svg";